import * as _ from 'underscore';
import { util } from '../util';
import { Observable, Subject } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { IExtendedWindow } from '../../../type_definitions/datatypes';

export const EVENT_CLOSE_DIALOG:string = 'closeDialog';
export const EVENT_SHOW_FIELD_LABEL_COMMENTS:string = 'showFieldLabelComments';

export interface IGAEvent {
  name:string;
  data?:any;
}

@Injectable()
export class GaEventService {
  private subject:Subject<IGAEvent> = new Subject();
  public events:Observable<IGAEvent> = this.subject.asObservable();
  public static ALLOWED_EVENTS:string[] = [
    EVENT_CLOSE_DIALOG,
    EVENT_SHOW_FIELD_LABEL_COMMENTS
  ];

  constructor(
    @Inject(Window) window:IExtendedWindow
  ) {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
  }

  private receiveMessage:any = (e:any) => {
    try {
      const event = util.fromJson(e.data);
      const eventFound:boolean = _.contains(GaEventService.ALLOWED_EVENTS, event.message);
      if (eventFound) {
        this.subject.next({
          name: event.message,
          data: util.fromJson(event.data)
        });
      }
    } catch (exc) {
      // empty block
    }
  };

  public sendMessage(name:string, data?:any):void {
    this.subject.next({
      name,
      data
    });
  }
}